import { Empty, Card, Row, Col, Statistic, Divider, Tag, Spin, List, Avatar, PageHeader, Modal, Typography, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, dineroDisabledMask, TableItem } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { FilePdfOutlined } from "@ant-design/icons";
import ModalPdfCorteCaja from "../../../PuntoDeVenta/CorteCaja/ModalPdfCorteCaja/ModalPdfCorteCaja";

moment.locale("es");

const { Text } = Typography;

class VerSesion extends Component {
  state = {
    sesionInfo: null,
    ventas: [],
    loading: false,
    loadingVentas: false,
    totalVentas: 0,
    totalEfectivo: 0,
    totalTarjeta: 0,
    totalOtros: 0,
    totalRetiros: 0,
    totalIngresos: 0,
    pdfVisible: false,
  };

  componentDidMount() {
    this.consultarSesion();
    this.consultarVentasSesion();
  }

  consultarSesion = () => {
    this.setState({ loading: true });
    axios
      .post(
        "sesionesPV/selectSesion",
        {
          sesionId: this.props.match.params.id,
          empresaId: this.props.empresaId
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            sesionInfo: res.data.sesion
          });
          this.calcularTotalRetiros(res.data.sesion.retiros || [], res.data.sesion.ingresos || []);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar sesión:", error);
      });
  };

  consultarVentasSesion = () => {
    this.setState({ loadingVentas: true });
    axios
      .post(
        "sesionesPV/selectVentasSesion",
        {
          sesionId: this.props.match.params.id,
          empresaId: this.props.empresaId
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loadingVentas: false });
        if (res.data.success === 2) {
          const ventas = res.data.ventas;
          this.setState({
            ventas: ventas.map(value => {
              let numero = ''
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              if (value.facturaGlobal) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaGlobalSerie ? value.facturaGlobalSerie : 'FG') + ' ' + (value.facturaGlobalNumero ? value.facturaGlobalNumero : '')
              }
              if (value.remision) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              return {
                ...value,
                numero,
                fechaVenta: value.fechaFactura ? value.fechaFactura : value.fechaRemision,
                // cliente: (value?.cliente?.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
              };
            })
          });
          this.calcularTotales(ventas);
        }
      })
      .catch((error) => {
        this.setState({ loadingVentas: false });
        console.error("Error al consultar ventas:", error);
      });
  };

  cancelacionIngresoRetiro = (datoId, tipo) => {
    this.setState({ loading: true });
    axios
      .post(
        "sesionesPV/cambioEstadoIngresoRetiro",
        {
          sesionId: this.props.match.params.id,
          datoId,
          tipo,
          empresaId: this.props.empresaId
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Movimiento cancelado correctamente");
          this.consultarSesion();
        } else {
          message.error(res.data.message || "No se pudo cancelar el movimiento");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar sesión:", error);
      });
  }

  calcularTotales = (ventas) => {
    let totalVentas = 0;
    let totalEfectivo = 0;
    let totalTarjeta = 0;
    let totalOtros = 0;

    ventas.forEach(venta => {
      // Las canceladas (estado 0) se siguen listando, pero no suman
      if (venta.estado === 0) {
        return;
      }

      const total = parseFloat(venta.total || 0);
      totalVentas += total;

      switch (venta.metodoPago) {
        case 'efectivo':
          totalEfectivo += total;
          break;
        case 'tarjeta':
          totalTarjeta += total;
          break;
        default:
          totalOtros += total;
          break;
      }
    });

    this.setState({
      totalVentas,
      totalEfectivo,
      totalTarjeta,
      totalOtros
    });
  };

  calcularTotalRetiros = (retiros, ingresos) => {
  const totalRetiros = retiros.reduce((total, retiro) => {
    if (retiro.estado === 2) {
      return total + parseFloat(retiro.monto || 0);
    }
    return total;
  }, 0);
  
  const totalIngresos = ingresos.reduce((total, ingreso) => {
    if (ingreso.estado === 2) {
      return total + parseFloat(ingreso.monto || 0);
    }
    return total;
  }, 0);
  
  this.setState({ totalRetiros, totalIngresos });
};

  atras() {
    this.props.history.goBack();
  }

  render() {
    const { sesionInfo, ventas, loading, loadingVentas, totalVentas, totalRetiros, totalIngresos } = this.state;

    const handleCancelarIngreso = (ingresoId) => {
      Modal.confirm({
        title: '¿Está seguro de cancelar este ingreso?',
        content: 'Esta acción no se puede deshacer.',
        okText: 'Sí, cancelar',
        cancelText: 'No',
        okButtonProps: { danger: true },
        onOk: () => {
          this.cancelacionIngresoRetiro(ingresoId, 'ingreso');
        }
      });
    };

    const handleCancelarRetiro = (retiroId) => {
      Modal.confirm({
        title: '¿Está seguro de cancelar este retiro?',
        content: 'Esta acción no se puede deshacer.',
        okText: 'Sí, cancelar',
        cancelText: 'No',
        okButtonProps: { danger: true },
        onOk: () => {
          this.cancelacionIngresoRetiro(retiroId, 'retiro');
        }
      });
    };

    const columns = [
      {
        title: "Folio",
        dataIndex: "numero",
        key: "numero",
        width: "8%",
      },
      {
        title: "Cliente",
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        render: (text) => text || "Cliente General",
        width: "26%",
      },
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        render: (fecha) => moment(fecha).format("DD/MM/YYYY HH:mm"),
        width: "8%",
      },
      {
        title: "Método de Pago",
        dataIndex: "totalPagos",
        key: "totalPagos",
        render: (pagos) => {
          let tags = []

          if (pagos?.efectivo > 0) {
            tags.push(<Tag color="green" key="efectivo">Efe: {dineroDisabledMask(pagos?.efectivo)}</Tag>);
          }

          if (pagos?.tarjetaCredito > 0) {
            tags.push(<Tag color="blue" key="tarjeta">TDC.: {dineroDisabledMask(pagos?.tarjetaCredito)}</Tag>);
          }

          if (pagos?.tarjetaDebito > 0) {
            tags.push(<Tag color="purple" key="tarjetaDebito">TDD.: {dineroDisabledMask(pagos?.tarjetaDebito)}</Tag>);
          }

          if (pagos?.vales > 0) {
            tags.push(<Tag color="orange" key="vales">Val: {dineroDisabledMask(pagos?.vales)}</Tag>);
          }

          if (pagos?.cheque > 0) {
            tags.push(<Tag color="cyan" key="cheque">Cheq: {dineroDisabledMask(pagos?.cheque)}</Tag>);
          }

          if (pagos?.transferencia > 0) {
            tags.push(<Tag color="magenta" key="transferencia">Transf: {dineroDisabledMask(pagos?.transferencia)}</Tag>);
          }

          return <>{tags}</>;
        },
        width: "36%",
      },
      {
        title: "Subtotal",
        dataIndex: "subtotal",
        key: "subtotal",
        render: (subtotal) => `${dineroDisabledMask(subtotal || 0)}`,
        align: 'right',
        width: "8%",
      },
      {
        title: "Imp.",
        dataIndex: "totalImpuestos",
        key: "totalImpuestos",
        render: (impuestos, record) => `${dineroDisabledMask((record.total - record.subtotal) || 0)}`,
        align: 'right',
        width: "8%",
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        render: (totalPagar) => (
          <strong style={{ color: '#1890ff' }}>
            {dineroDisabledMask(totalPagar || 0)}
          </strong>
        ),
        align: 'right',
        width: "8%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (estado) => {
          let color = "default";
          let texto = estado;

          switch (estado) {
            case 3:
              color = "green";
              texto = "Entregada";
              break;
            case 2:
              color = "orange";
              texto = "Parcialmente";
              break;
            case 1:
              color = "blue";
              texto = "Sin entregar";
              break;
            case 0:
              color = "red";
              texto = "Cancelada";
              break;
            default:
              texto = estado || "Sin estado";
              break;
          }

          return <Tag color={color}>{texto}</Tag>;
        },
        width: "10%",
      },
    ];

    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" />
        </div>
      );
    }

    const retiros = sesionInfo?.retiros || [];
    const ingresos = sesionInfo?.ingresos || [];

    return (
      <div>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Ver Sesión"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={ sesionInfo?.fechaFinal &&
            <ButtonItem blanco icon={<FilePdfOutlined />} onClick={() => this.setState({ pdfVisible: true })}>
              Pdf
            </ButtonItem>
          }
        />
        {/* Información de la sesión */}
        {sesionInfo && (
          <Card style={{ marginBottom: 20 }}>
            <Row gutter={16}>
              <Col span={8}>
                <Statistic
                  title="Fecha Inicial"
                  value={moment(sesionInfo.fechaInicial).format("DD/MM/YYYY HH:mm")}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Fecha Final"
                  value={sesionInfo.fechaFinal
                    ? moment(sesionInfo.fechaFinal).format("DD/MM/YYYY HH:mm")
                    : "En Curso"
                  }
                />
              </Col>
              <Col span={8}>
                <Statistic
                  title="Estado"
                  value={sesionInfo.fechaFinal ? "Cerrada" : "Activa"}
                  valueStyle={{
                    color: sesionInfo.fechaFinal ? '#52c41a' : '#faad14'
                  }}
                />
              </Col>
            </Row>
            {sesionInfo.observaciones && (
              <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                  <Text strong>Observaciones: </Text>
                  <Text>{sesionInfo.observaciones}</Text>
                </Col>
              </Row>
            )}
          </Card>
        )}

        {/* Resumen de ventas */}
        <Card title="Resumen de Ventas" style={{ marginBottom: 20 }}>
          <Row gutter={16}>
            <Col span={6}>
              <Statistic
                title="Total de Ventas"
                value={ventas.filter((venta) => venta.estado !== 0).length}
                suffix="ventas"
                valueStyle={{ color: '#1890ff' }}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Total General"
                value={dineroDisabledMask(totalVentas)}
                valueStyle={{ color: '#f5222d', fontSize: '24px' }}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Total Retiros"
                value={"- " + dineroDisabledMask(totalRetiros)}
                valueStyle={{ color: '#fa8c16', fontSize: '18px' }}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Total Ingresos"
                value={dineroDisabledMask(totalIngresos)}
                valueStyle={{ color: '#fa8c16', fontSize: '18px' }}
              />
            </Col>
          </Row>
        </Card>

        {/* Retiros de Caja */}
        <Card title="Ingresos de Caja" style={{ marginBottom: 20 }}>
          {ingresos.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={ingresos}
              renderItem={(ingreso, index) => (
                <List.Item
                  actions={[
                    (ingreso.estado === 2 && !sesionInfo.fechaFinal) ? (
                      <ButtonItem 
                        type="primary" 
                        rojo 
                        size="small"
                        onClick={() => handleCancelarIngreso(ingreso._id)}
                      >
                        Cancelar
                      </ButtonItem>
                    ) : ingreso.estado === 0 ? (
                      <Tag color="red">Cancelada</Tag>
                    ) : null
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        style={{ backgroundColor: '#fa8c16' }}
                        icon="💰"
                      >
                        {index + 1}
                      </Avatar>
                    }
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold' }}>
                          {ingreso.descripcion || 'Sin descripción'}
                        </span>
                        <Tag color="orange" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          {dineroDisabledMask(ingreso.monto || 0)}
                        </Tag>
                      </div>
                    }
                    description={`Ingreso ID: ${ingreso._id}`}
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No hay ingresos registrados en esta sesión"
            />
          )}
        </Card>

        {/* Retiros de Caja */}
        <Card title="Retiros de Caja" style={{ marginBottom: 20 }}>
          {retiros.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={retiros}
              renderItem={(retiro, index) => (
                <List.Item
                  actions={[
                    (retiro.estado === 2 && !sesionInfo.fechaFinal) ? (
                      <ButtonItem
                        type="primary"
                        rojo
                        size="small"
                        onClick={() => handleCancelarRetiro(retiro._id)}
                      >
                        Cancelar
                      </ButtonItem>
                    ) : retiro.estado === 0 ? (
                      <Tag color="red">Cancelada</Tag>
                    ) : null
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        style={{ backgroundColor: '#fa8c16' }}
                        icon="💰"
                      >
                        {index + 1}
                      </Avatar>
                    }
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold' }}>
                          {retiro.descripcion || 'Sin descripción'}
                        </span>
                        <Tag color="orange" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          - {dineroDisabledMask(retiro.monto || 0)}
                        </Tag>
                      </div>
                    }
                    description={`Retiro ID: ${retiro._id}`}
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No hay retiros registrados en esta sesión"
            />
          )}
        </Card>

        <Divider />

        {/* Tabla de ventas */}
        <Card title="Detalle de Ventas">
          <TableItem
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <>
                      <p>
                        No hay ventas registradas en esta sesión.
                      </p>
                    </>
                  }
                />
              ),
            }}
            loading={loadingVentas}
            size="small"
            dataSource={ventas}
            columns={columns}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} ventas`,
            }}
            scroll={{ x: 800 }}
            summary={(pageData) => {
              let totalPagina = 0;
              pageData.forEach(({ total, estado }) => {
                if (estado === 0) {
                  return;
                }
                totalPagina += parseFloat(total || 0);
              });

              return (
                <TableItem.Summary.Row>
                  <TableItem.Summary.Cell index={0} colSpan={6}>
                    <strong>Total de la página:</strong>
                  </TableItem.Summary.Cell>
                  <TableItem.Summary.Cell index={6}>
                    <strong style={{ color: '#1890ff' }}>
                      {dineroDisabledMask(totalPagina)}
                    </strong>
                  </TableItem.Summary.Cell>
                  <TableItem.Summary.Cell index={7} />
                </TableItem.Summary.Row>
              );
            }}
          />
        </Card>
        <ModalPdfCorteCaja
          visible={this.state.pdfVisible}
          cerrarModalPdfCorteDeCaja={() => this.setState({ pdfVisible: false })}
          id={this.props.match.params.id}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerSesion);